<template>
  <div id="page-wrapper">
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor">{{ $t('nav.onboard') }}</h3>
      </div>
      <div class="col-md-7 align-self-center">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.home') }}</a></li>
          <li class="breadcrumb-item active">{{ $t('nav.onboard') }}</li>
        </ol>
      </div>
    </div>
    <div class="container-fluid">
      <!-- /row -->
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="card">
            <div class="card-header">
              <div class="pull-right">
                <el-button type="primary" size="small" round @click="createNew">{{ $t('onboard.new') }}</el-button>
              </div>
              <el-input :placeholder="$t('staff.search-ph')" v-model="keyword" class="input-with-select" style="width:300px">
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <div class="card-body">
              <el-table
                ref="filterTable"
                :data="staff.filter(data => !keyword || data.eName.toLowerCase().includes(keyword.toLowerCase()))"
                style="width: 100%"
                @row-click="editInfo">
                <el-table-column
                  prop="eName"
                  :label="$t('onboard.e-name')"
                  sortable
                  width="140"
                >
                </el-table-column>
                
                <el-table-column
                  prop="onboardDate"
                  sortable
                  :label="$t('onboard.onboard-date')"
                  width="120"
                  >
                </el-table-column>
                <el-table-column
                  prop="eTitle"
                  :label="$t('onboard.e-title')"
                  sortable
                  >
                </el-table-column>
                <el-table-column
                  prop="teamName"
                  sortable
                  :label="$t('onboard.team')"
                  :filters="teamFilters"
                    :filter-method="filterTeam"
                    column-key="teamName"
                  >
                </el-table-column>
                <el-table-column
                  prop="userTypeName"
                  sortable
                  :label="$t('onboard.user-type')"
                  :filters="userTypeFilters"
                    :filter-method="filterUserType"
                    column-key="userTypeName"
                    width="150"
                  >
                </el-table-column>
                <el-table-column
                  prop="lineManager"
                  :label="$t('onboard.line')"
                  sortable
                  >
                </el-table-column>
                
                
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'OnboardList',
  components: {
  },
  data: function() {
  return {
    staff: [],
    keyword: null
  }
  },
  computed: {
    teamFilters: function() {
    let filter = this.team,
        that = this
    filter.forEach(function(v) {
      v.text = that.$i18n.locale === 'zh' ? v.c_name : v.e_name
      v.value = v.id
    })
    return filter
  },
    userTypeFilters: function() {
      let filter = this.userType,
        that = this
    filter.forEach(function(v) {
      v.text = that.$i18n.locale === 'zh' ? v.c_name : v.e_name
      v.value = v.id
    })
    return filter
    }
  },
  methods: {
    filterUserType: function(value, row) {
      return row.userType === value
    },
    filterTeam: function(value, row) {
      return row.team === value
    },
    editInfo: function(row, column, event) {
      //console.log(row)
      this.$router.push({ path: '/onboard/edit/' + row.id })
    },
    createNew: function() {
      this.$router.push({ path: '/onboard/new' })
    },
    loadData: function() {
      let that = this

    this.$http.get(this.API3_PREFIX + 'onboard_list').then(function (response) {
    that.staff = response.data
    that.staff.forEach(function(v) {
      if (v.team != null)
        v.teamName = that.getTeam(v.team)
      if (v.userType != null)
        v.userTypeName = that.getUserType(v.userType)
    })
      }).catch(function (error) {
    console.log(error)
      })
    }
  },
  created: function() {
    this.loadData()
  }
}
</script>